import type {AssortmentItem, AssortmentType} from '../../types';

import {Loading} from '@ds/components';
import barcode from 'assets/images/barcode.svg';
import Empty from 'common/empty/Empty';

import AssortmentListItem from './components/AssortmentListItem/AssortmentListItem';

type AssortmentListProps = {
  items: AssortmentItem[];
  assortmentType: AssortmentType;
  loading: boolean;
  requestSucceeded: boolean;
  onStatusClick: (item: AssortmentItem) => void;
  onDetailsClick: () => void;
};

const AssortmentList: React.FC<AssortmentListProps> = ({
  items,
  assortmentType,
  loading,
  requestSucceeded,
  onStatusClick,
  onDetailsClick
}) => {
  if (loading) {
    return (
      <div className="flex flex-1 justify-center pt-6">
        <Loading size="medium" />
      </div>
    );
  }

  if (requestSucceeded && items.length === 0) {
    return (
      <div className="flex flex-1 flex-col items-center justify-center gap-6">
        <Empty illustration={barcode} />
        <span className="text-subtitle-sm text-gray-09">کالایی با این ویژگی ندارید</span>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      {items.map((item, index) => (
        <AssortmentListItem
          key={`${item.product_title ?? 'product'}-${index}`}
          item={item}
          assortmentType={assortmentType}
          onStatusClick={() => onStatusClick(item)}
          onDetailsClick={onDetailsClick}
        />
      ))}
    </div>
  );
};

export default AssortmentList;
